function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.currentVariantId = this.querySelector('.currentVariantId');
    this.plusBtn = this.querySelector('button[name="plus"]');
    this.minusBtn = this.querySelector('button[name="minus"]');
    this.ariaElem = this.querySelector('[data-aria-live]');
    this.changeEvent = new Event('change', { bubbles: true });
    this._announceClearTimer = null;
    this._suppressAnnounce = false;

    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });

    if (this.input) {
      // Native type=number fires input on ArrowUp/ArrowDown and typing.
      this.input.addEventListener('input', this.onInputCommit.bind(this));
      this.input.addEventListener('change', this.onInputCommit.bind(this));
      this.input.addEventListener('blur', () => {
        this.syncInputMax();
        this.clampInputValue();
        this.syncButtonState();
      });
    }

    this.syncInputMax();
    this.syncButtonState();
  }

  getAllVariantInventory() {
    return Array.from(this.querySelectorAll('.variantInventory')).map((varEl) => ({
      id: varEl.dataset.varid,
      quantity: varEl.dataset.quant,
    }));
  }

  getVariantDataValues() {
    const jsonEl = document.querySelector('[type="application/json"]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  getQuantLimit() {
    if (!this.currentVariantId) return null;

    const currentVariantID = this.currentVariantId.dataset.vid;
    const variantInventoryElements = this.getAllVariantInventory();
    let quantLimit = null;

    for (const vIEl of variantInventoryElements) {
      if (vIEl.id === currentVariantID) {
        const parsed = parseInt(vIEl.quantity, 10);
        quantLimit = Number.isFinite(parsed) ? parsed : null;
        break;
      }
    }

    return quantLimit;
  }

  syncInputMax() {
    if (!this.input) return;

    const limit = this.getQuantLimit();
    if (limit != null && limit > 0) {
      this.input.setAttribute('max', String(limit));
    } else {
      this.input.removeAttribute('max');
    }
  }

  /**
   * Use native `disabled` so buttons are skipped in the tab order.
   * Visual opacity class is kept for existing sticky-ATC styling.
   */
  syncButtonState() {
    if (!this.input) return;

    const newVal = parseInt(this.input.value, 10) || 1;
    const limit = this.getQuantLimit();

    if (this.minusBtn) {
      const atMin = newVal <= 1;
      this.minusBtn.disabled = atMin;
      this.minusBtn.removeAttribute('aria-disabled');
      this.minusBtn.removeAttribute('tabindex');
    }

    if (this.plusBtn) {
      const atMax = limit != null && limit > 0 && newVal >= limit;
      this.plusBtn.disabled = atMax;
      this.plusBtn.classList.toggle('disableQuantitySelector', atMax);
      this.plusBtn.removeAttribute('aria-disabled');
      this.plusBtn.removeAttribute('tabindex');
    }
  }

  /**
   * Announce via a polite live region, then clear so browse mode does not
   * stop on stale "Item increased by 1" text in the Sticky ATC.
   */
  announceQuantityChange(message) {
    if (!this.ariaElem || !message) return;

    clearTimeout(this._announceClearTimer);
    this.ariaElem.textContent = '';

    window.requestAnimationFrame(() => {
      this.ariaElem.textContent = message;
      this._announceClearTimer = window.setTimeout(() => {
        if (this.ariaElem) this.ariaElem.textContent = '';
      }, 1500);
    });
  }

  clampInputValue() {
    if (!this.input) return 1;

    const min = parseInt(this.input.getAttribute('min'), 10) || 1;
    const maxAttr = this.input.getAttribute('max');
    const max = maxAttr != null && maxAttr !== '' ? parseInt(maxAttr, 10) : null;
    let val = parseInt(this.input.value, 10);

    if (!Number.isFinite(val) || val < min) val = min;
    if (max != null && Number.isFinite(max) && val > max) val = max;

    this.input.value = String(val);
    return val;
  }

  /** Called after variant changes reset quantity to 1. */
  syncAfterVariantChange() {
    this.syncInputMax();
    this.clampInputValue();
    this.syncButtonState();
  }

  onInputCommit() {
    if (!this.input || this._suppressAnnounce) return;

    this.syncInputMax();
    const previousValue = this.input.dataset.prevValue || this.input.defaultValue || '1';
    const newVal = this.clampInputValue();
    this.syncButtonState();

    if (String(previousValue) !== String(newVal)) {
      this.announceQuantityChange(`Quantity ${newVal}`);
    }

    this.input.dataset.prevValue = String(newVal);
  }

  onButtonClick(event) {
    event.preventDefault();

    const button = event.currentTarget;
    if (!button || button.disabled) return;

    this.syncInputMax();

    const previousValue = this.input.value;
    const isPlus = button.name === 'plus';
    const isMinus = button.name === 'minus';

    this._suppressAnnounce = true;
    if (isPlus) this.input.stepUp();
    else this.input.stepDown();
    this.clampInputValue();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
    this._suppressAnnounce = false;

    const newVal = parseInt(this.input.value, 10) || 1;
    this.syncButtonState();
    this.input.dataset.prevValue = String(newVal);

    if (isMinus && previousValue === '1' && newVal === 1) {
      this.announceQuantityChange('Minimum quantity is 1');
      return;
    }

    if (previousValue === this.input.value) return;

    this.announceQuantityChange(
      isMinus ? `Quantity decreased to ${newVal}` : `Quantity increased to ${newVal}`
    );
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options['method'] || 'post';
  const params = options['parameters'] || {};

  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (const key in params) {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.statusElem = document.querySelector('#pdp-variant-status');
    this.addEventListener('change', this.onVariantChange);
    this.ProductContainer = this.closest('.product');
  }

  connectedCallback() {
    this.updateOptions();
    this.updateMasterId();
    if (!this.closest('[data-quickview-modal]')) this.updateTitle();
  }

  onVariantChange() {
    _theme.toggleLoading(1);
    this.isQuickview = this.closest('[data-quickview-modal]') ? true : false;
    this.updateOptions();
    this.updateMasterId();
    this.updateProductQuantity();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.updateOptionLabel();
    this.toggleQuantityButtonState();
    this.dispatchEvent(new CustomEvent('variant:changed'));

    const productId = this.getAttribute('data-product-id');
    if (productId) {
      document.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: {
            productId,
            variantId: this.currentVariant?.id || null,
          },
        })
      );
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      if (!this.isQuickview) {
        this.updateURL();
        this.updateTitle();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateKlarnaWidget();
      if (window._ltk && this.currentVariant.sku) {
        window._ltk.Activity.AddProductBrowse(this.currentVariant.sku);
      }

      // Update variant data on product container when variant changes (for tracking)
      if (this.isQuickview) {
        const productContainer = document.querySelector('.product');
        if (productContainer && this.currentVariant) {
          productContainer.setAttribute(
            'data-current-variant',
            JSON.stringify(this.currentVariant)
          );
        }
      }

      setTimeout(() => {
        this.updateRegionStatus(this.preparePriceChangeTextForSROnly());
      }, 250);
    }
  }

  updateTitle() {
    if (!this.currentVariant || this.isQuickview) return;
    const size = this.currentVariant.option1;
    if (size && size !== 'Default Title') {
      const baseTitle = document.title.split(/ [–\-\|] /)[0].trim();
      document.title = `${baseTitle} - ${size}`;
    }
  }

  updateRegionStatus(msg, forceEmpty = true) {
    if (!this.statusElem || !msg) return;
    this.statusElem.textContent = msg;
    if (!forceEmpty) return;
    setTimeout(() => {
      this.statusElem.textContent = '';
    }, 500);
  }

  preparePriceChangeTextForSROnly() {
    if (!this.currentVariant) return;

    let text = `Sale Price: ${Shopify.formatMoney(this.currentVariant.price)}`;
    if (this.currentVariant.compare_at_price) {
      text += ` Regular Price: ${Shopify.formatMoney(this.currentVariant.compare_at_price)}`;

      const diff = this.currentVariant.compare_at_price - this.currentVariant.price;
      text += ` You Save: ${Shopify.formatMoney(diff)}`;
    }

    return text;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionLabel() {
    if (!this.currentVariant) return;
    const currentSelected1 = document.querySelector('.current-selected-1');
    const currentSelected2 = document.querySelector('.current-selected-2');
    const currentSelected3 = document.querySelector('.current-selected-3');
    const ozValue = 29.5735;
    const unitConvertArr = this.currentVariant.option1.split('oz');
    const selectedVal = this.currentVariant.option1;
    let selectedValSliced;
    if (this.currentVariant.option1.includes('oz')) {
      selectedValSliced = selectedVal.slice(0, selectedVal.length - 1);
    } else {
      selectedValSliced = selectedVal.slice(0, selectedVal.length);
    }
    if (selectedVal.includes('Tester')) {
      const selectedValArr = selectedVal.split('Tester');
      selectedValSliced = selectedValArr[0].slice(0, selectedValArr[0].length - 2);
      selectedValSliced = selectedValSliced + ' Tester';
    }
    const unitConvertArrValue = Number(unitConvertArr[0]);

    const conversions = {
      0.05: 1.5,
      0.17: 5,
      0.5: 15,
      0.8: 25,
      1.0: 30,
      1.4: 40,
      1.7: 50,
      2.0: 60,
      2.5: 75,
      2.7: 80,
      3.0: 90,
      3.3: 100,
      3.4: 100,
      4.2: 125,
      5.0: 150,
      6.7: 200,
    };
    const unitValue = conversions[unitConvertArrValue] || Math.floor(ozValue * unitConvertArrValue);

    if (currentSelected1) currentSelected1.textContent = `${selectedValSliced}`;
    if (this.currentVariant.option1.includes('oz')) {
      currentSelected1.textContent = `${selectedValSliced} / ${unitValue}ml`;
    } else {
      if (currentSelected1) currentSelected1.textContent = `${selectedValSliced}`;
    }
    if (currentSelected2) currentSelected2.textContent = this.currentVariant.option2;
    if (currentSelected3) currentSelected3.textContent = this.currentVariant.option3;
  }

  updateProductQuantity() {
    if (!this.currentVariant) return;
    const quantityValue = document.querySelector('.quantity__input');
    if (quantityValue) quantityValue.value = 1;

    const quantityInput = document.querySelector('quantity-input');
    if (quantityInput && typeof quantityInput.syncAfterVariantChange === 'function') {
      quantityInput.syncAfterVariantChange();
    }
  }
  toggleQuantityButtonState() {
    const plusBtn = document.querySelector('.quantity__button[name="plus"]');
    if (!plusBtn) return;

    plusBtn.classList.remove('disableQuantitySelector');
    plusBtn.disabled = false;
    plusBtn.removeAttribute('aria-disabled');
    plusBtn.removeAttribute('tabindex');

    const quantityInput = document.querySelector('quantity-input');
    if (quantityInput && typeof quantityInput.syncAfterVariantChange === 'function') {
      quantityInput.syncAfterVariantChange();
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    document.querySelector('.currentVariantId').dataset.vid = this.currentVariant.id;
    const size = this.currentVariant.option1;
    const media_id = this.currentVariant.featured_media && this.currentVariant.featured_media.id;

    // Scope selection to the current section (Main PDP or Quickview)
    const section = this.closest('section') || this.closest('.shopify-section') || document;
    const slideshowGallery = section.querySelector('slideshow-container.product-main-slider');
    const slideshowThumbs = section.querySelector('slideshow-container.thumbnail-slider');

    if (slideshowGallery && slideshowGallery.swiper) {
      let targetSlide = -1;
      if (media_id) {
        const slide = slideshowGallery.querySelector(`slideshow-container-item[data-mediaid='${media_id}']`);
        if (slide) targetSlide = Array.from(slide.parentElement.children).indexOf(slide);
      }

      if (targetSlide === -1) {
        const slide = slideshowGallery.querySelector(`slideshow-container-item[data-mediaalt='${size}']`);
        if (slide) targetSlide = Array.from(slide.parentElement.children).indexOf(slide);
      }

      if (targetSlide !== -1) {
        slideshowGallery.swiper.slideTo(targetSlide);
        // Highlight is handled by the swiper:slideChange listener or call it manually for instant feedback
        if (typeof window.updateThumbnailActiveState === 'function') {
           window.updateThumbnailActiveState(slideshowThumbs, targetSlide);
        }
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    window.history.replaceState({}, '', variantUrl);

    const canonicalEl = document.querySelector('link[rel="canonical"]');
    if (canonicalEl) {
      canonicalEl.setAttribute('href', new URL(variantUrl, window.location.origin).href);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.querySelectorAll('.priceSection');
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const sourcePrice = html.querySelector(`.priceSection`);
        if (sourcePrice && destination.length) {
          destination.forEach((des) => {
            des.innerHTML = sourcePrice.innerHTML;
          });
        }

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const freeShipDestination = this.ProductContainer.querySelector('[data-freeshipnote]');
        const freeShipSource = html.querySelector('[data-freeshipnote]');
        if (freeShipDestination && freeShipSource) {
          freeShipDestination.innerHTML = freeShipSource.innerHTML;
          freeShipDestination.className = freeShipSource.className;
        }

        const wishlistBtnDestination = this.ProductContainer.querySelectorAll('.pdp-wishlist-prod');
        const wishlistBtnSource = html.querySelector('.pdp-wishlist-prod');
        if (wishlistBtnDestination.length && wishlistBtnSource) {
          wishlistBtnDestination.forEach(function (destination) {
            destination.innerHTML = wishlistBtnSource.innerHTML;
          });
        }

        _theme.toggleLoading(0);

        const parent = html.getElementById(`ProductInfo-${this.dataset.section}`);
        const variantCont = parent.closest('.product-shop').querySelector('variant-radios');
        const variantSelected = variantCont.firstElementChild.querySelectorAll('input');

        const labelsDestinations = this.ProductContainer.querySelectorAll('[data-label]');
        const labelsSources = html.querySelectorAll('[data-label]');
        if (labelsDestinations.length && labelsSources.length) {
          labelsDestinations.forEach(function (dst, index) {
            dst.innerHTML = labelsSources[index].innerHTML;
          });
        }

        this.syncTagDescriptions(this.ProductContainer, html);

        _theme.Wishlist.init();
        _theme.toggleLoading(0);
      });
  }

  syncTagDescriptions(ProductContainer, html) {
    try {
      const tagDescDestinations = ProductContainer.querySelectorAll(
        '.ctm-product-tags-description'
      );
      const tagDescSources = html.querySelectorAll('.ctm-product-tags-description');
      const tagsContainer = ProductContainer.querySelector(
        '.product__info-container variant-radios'
      );

      // Remove existing if no sources
      if (tagDescSources.length === 0) {
        tagDescDestinations.forEach((el) => el.remove());
        return;
      }

      // Clear existing destinations
      tagDescDestinations.forEach((el) => el.remove());

      // Insert new containers
      tagDescSources.forEach((source) => {
        const container = document.createElement('div');
        container.className = 'ctm-product-tags-description';
        container.innerHTML = source.innerHTML;
        tagsContainer.insertAdjacentElement('afterend', container);
      });
    } catch (error) {
      console.error('Error syncing tag descriptions:', error);
    }
  }

  toggleAddButton(disable = false, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const checkoutButton = productForm.querySelector('[name="custom_checkout"]');
    const checkoutButtonText = productForm.querySelector('[name="custom_checkout"] > span');
    const quantityButtons = document.querySelector('.product-shop .product-form__quantity');
    if (!addButton) return;

    if (!this.currentVariant.available) {
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = 'Out of Stock';
      if (checkoutButton) {
        checkoutButton.setAttribute('disabled', 'disabled');
        checkoutButtonText.textContent = 'Buy It Now';
      }
      quantityButtons.querySelector('[name="plus"]').setAttribute('disabled', 'disabled');
      quantityButtons.querySelector('[name="minus"]').setAttribute('disabled', 'disabled');

      if (_theme.isIpad) {
        productForm.closest('.product-form-div').classList.add('noStock');
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (checkoutButton) {
        checkoutButton.removeAttribute('disabled');
        checkoutButtonText.textContent = 'Buy It Now';
      }
      quantityButtons.querySelector('[name="plus"]').removeAttribute('disabled');
      quantityButtons.querySelector('[name="minus"]').removeAttribute('disabled');

      if (_theme.isIpad) {
        productForm.closest('.product-form-div').classList.remove('noStock');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const bisForm = document.querySelector('[data-backinstockform]');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (bisForm) bisForm.classList.add('hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);

    return this.variantData;
  }

  updateKlarnaWidget() {
    const klarna = document.querySelector('.product-shop klarna-placement');
    if (!klarna || !this.currentVariant) return;
    klarna.setAttribute('data-purchase-amount', this.currentVariant.price);
    _theme.Helpers.refreshKlarna();
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// PDP Slider Synchronisation - Utility to highlight active thumbnail
window.updateThumbnailActiveState = (thumbsContainer, index) => {
  if (!thumbsContainer) return;
  const items = thumbsContainer.querySelectorAll('slideshow-container-item');
  items.forEach((item, idx) => {
    const isActive = idx === index;
    item.classList.toggle('is-active', isActive);
    const button = item.querySelector('button');
    if (button) {
      // Save the original aria-label the first time we see it
      if (!button.hasAttribute('data-original-aria-label')) {
        button.setAttribute('data-original-aria-label', button.getAttribute('aria-label') || '');
      }

      const originalLabel = button.getAttribute('data-original-aria-label');
      if (originalLabel) {
        button.setAttribute('aria-label', originalLabel);
      }

      if (isActive) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    }
  });
};

// PDP Slider Synchronisation - Listen for Swiper events on product galleries
document.addEventListener('swiper:slideChangeTransitionStart', (e) => {
  const gallery = e.target;
  if (!gallery.classList.contains('product-main-slider')) return;
  
  const section = gallery.closest('section') || gallery.closest('.shopify-section') || document;
  const activeIndex = e.detail.swiper.activeIndex;

  // 1. Sync all main sliders (e.g. Desktop and Mobile versions)
  const allMainSliders = section.querySelectorAll('slideshow-container.product-main-slider');
  allMainSliders.forEach(otherGallery => {
    if (otherGallery !== gallery && otherGallery.swiper) {
      otherGallery.swiper.slideTo(activeIndex);
    }
  });

  // 2. Sync thumbnails
  const slideshowThumbs = section.querySelector('slideshow-container.thumbnail-slider');
  if (slideshowThumbs && slideshowThumbs.swiper) {
    // Highlight the thumbnail
    window.updateThumbnailActiveState(slideshowThumbs, activeIndex);
    
    // Only slide if there are hidden thumbnails to bring into view (more than visible count)
    if (slideshowThumbs.swiper.slides.length > slideshowThumbs.swiper.params.slidesPerView) {
      slideshowThumbs.swiper.slideTo(activeIndex);
    }
  }
});

// PDP Slider Synchronisation - Ensure initial state on init
document.addEventListener('swiper:init', (e) => {
  const gallery = e.target;
  if (!gallery.classList.contains('product-main-slider')) return;
  
  const section = gallery.closest('section') || gallery.closest('.shopify-section') || document;
  const slideshowThumbs = section.querySelector('slideshow-container.thumbnail-slider');
  if (slideshowThumbs) {
    window.updateThumbnailActiveState(slideshowThumbs, e.detail.swiper.activeIndex);
  }
});

// PDP Slider Synchronisation - Handle thumbnail clicks to move main slider
document.addEventListener('click', (e) => {
  const thumbItem = e.target.closest('.product-thumb-slider slideshow-container-item');
  if (thumbItem) {
    const section = thumbItem.closest('section') || thumbItem.closest('.shopify-section') || document;
    const gallery = section.querySelector('slideshow-container.product-main-slider');
    if (gallery && gallery.swiper) {
      const index = Array.from(thumbItem.parentElement.children).indexOf(thumbItem);
      gallery.swiper.slideTo(index);
      // Highlight will be updated by the swiper:slideChange event on the gallery
    }
  }
});
